import * as Schema from "effect/Schema";

export const ToolDefinition = Schema.Struct({
  name: Schema.String,
  title: Schema.String,
  description: Schema.String,
  inputSchema: Schema.Record(Schema.String, Schema.Unknown),
  output: Schema.Struct({
    declared: Schema.Boolean,
    schema: Schema.Unknown,
    description: Schema.String,
  }),
  origin: Schema.Literals(["world", "device"]),
  execution: Schema.Struct({
    eligible: Schema.Boolean,
    onGrant: Schema.Boolean,
    policyAllows: Schema.Boolean,
    grantRequired: Schema.Boolean,
    checkOnCall: Schema.Literal(true),
  }),
});
export type ToolDefinition = typeof ToolDefinition.Type;
export const ToolCatalogPage = Schema.Struct({
  tools: Schema.Array(ToolDefinition),
  total: Schema.Number,
  nextCursor: Schema.NullOr(Schema.String),
  note: Schema.String,
});
export type ToolCatalogPage = typeof ToolCatalogPage.Type;

/** Where a seated tool came from (I6, TOOL8): the person's explicit session
 * choice, the room's board declaration, or the general fold's winning layer. */
export const SessionToolSource = Schema.Literals([
  "session",
  "room",
  "world",
  "person",
  "platform",
]);
export type SessionToolSource = typeof SessionToolSource.Type;
export const SessionToolSelection = Schema.Struct({
  sessionId: Schema.String,
  roomId: Schema.String,
  revision: Schema.Number,
  toolNames: Schema.NullOr(Schema.Array(Schema.String)),
  defaultTools: Schema.Array(Schema.String),
  effectiveTools: Schema.Array(Schema.String),
  governingScope: Schema.optional(SessionToolSource),
  sources: Schema.optional(Schema.Record(Schema.String, SessionToolSource)),
});
export type SessionToolSelection = typeof SessionToolSelection.Type;
/** One layer of the general session defaults: a list, or null where a
 * person's layer inherits; absent (null at the top) where nothing was set. */
const GeneralSessionDefaultsLayer = Schema.NullOr(
  Schema.Struct({
    tools: Schema.NullOr(Schema.Array(Schema.String)),
    setAt: Schema.Number,
    reason: Schema.NullOr(Schema.String),
  }),
);
/** The general fold a general session starts with (TOOL8): platform, then
 * the World's, then the person's; `tools` is the fold, `effectiveTools` the
 * fold narrowed by the grant, policy and reach as a bare read. */
export const GeneralSessionDefaults = Schema.Struct({
  worldKey: Schema.String,
  platform: Schema.Array(Schema.String),
  world: GeneralSessionDefaultsLayer,
  person: GeneralSessionDefaultsLayer,
  tools: Schema.Array(Schema.String),
  effectiveTools: Schema.Array(Schema.String),
  governingScope: Schema.Literals(["world", "person", "platform"]),
});
export type GeneralSessionDefaults = typeof GeneralSessionDefaults.Type;
